import { P_SINGLE, SET_SINGLE_PACKAGE_CRITERIA, SET_DD_VALUES } from './types'
//const initialState = {

//};

const initialState = {
    singlePackageCriteria:
    {
        academicYear: "",
        financialAidYear: "",
        packageEnrollmentIntensity: 100,
        packageAsLoad: "",
        directCost: "",
        distributionForAwardType: "",
        updateExistingStatusRecords: false,
        useSAI: true,
        rowCount: undefined,
        totalDistributionPercent: undefined
    }
};

const singlePackageReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case P_SINGLE:
            return {
                ...payload
            }
        case SET_SINGLE_PACKAGE_CRITERIA:
            return {
                ...state,
                singlePackageCriteria: payload
            }
        case SET_DD_VALUES:
            return {
                ...state,
                ddValues: payload
            }
        default:
            return state;
    }
}
export default singlePackageReducer;